import React from 'react';
import CollapsibleSection from 'components/collapsible/collapsible-section';
import InsightsChart from './insights-chart';

//#region Types
export type AreaListingsPageCollapsibleGuideProps = {
  isActive: boolean;
  title: string;
  className?: string;
  testId?: string;
  onCollapsibleSectionClick(): void;
};
//#endregion


export const AreaListingsPageMarketInsights = ({
  isActive,
  title,
  className,
  testId,
  onCollapsibleSectionClick,
}: AreaListingsPageCollapsibleGuideProps) => {
  return (
    <CollapsibleSection
      isActive={isActive}
      title={title}
      className={className}
      testId={testId}
      onClick={onCollapsibleSectionClick}
    >
      <InsightsChart />
    </CollapsibleSection>
  );
};
